<template>
  <transition name="fade">
    <div v-if="showing" class="background" data-testid="deck-embedded-splash-screen" @click="onClick">
      <h2 class="text-2xl mb-2 lg_text-5xl">Click to explore.</h2>
      <p class="text-xs lg_text-lg mb-4">Choose your own adventure with interactive content, or just press next.</p>
      <img class="h-6 mx-auto lg_absolute lg_h-8 md_right-4 md_bottom-4" src="~/assets/images/deck-splash-logo.png" alt="VRIFY Deck" />
    </div>
  </transition>
</template>

<script lang="ts" setup>
const emit = defineEmits(['dismiss-embed-overlay'])
const showing: Ref<boolean> = ref(true)

function onClick() {
  showing.value = false

  emit('dismiss-embed-overlay')
}
</script>

<style lang="stylus" scoped>
.background
  background-color: rgba(black, 0.8)

  @apply cursor-pointer absolute inset-0 h-full w-full grid text-center place-content-center text-white font-medium


.fade-enter-active, .fade-leave-active
  transition: opacity .7s

.fade-enter, .fade-leave-to
  opacity: 0
</style>
